import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar",
  "aria-label": "product configurator navigation"
}
const _hoisted_2 = {
  href: "/",
  class: "logo",
  "aria-label": "link to homepage"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", {
        src: $props.isLandingPage ? '/assets/images/icons/logo-white.svg' : '/assets/images/icons/logo-primary.svg',
        alt: "thredd logo"
      }, null, 8, _hoisted_3)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      href: "/",
      class: "homeBtn",
      "aria-label": "link to homepage"
    }, " Back to home ", -1))
  ]))
}